import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import FieldTypeSelector from "./FieldTypeSelector";
import {custom, input} from "../../utils/linker";
import Popup from "../Helpers/Popup";
import FieldSettings from "./FieldSettings";
import ShortDescription from "./ShortDescription";
import reactionCombiner from "../../utils/reactionCombiner";
import {ComponentContext} from "../../contexts";

function FieldRow(props) {
  const store = useLocalObservable(() => ({
    show_options: false,
    comb:null
  }));
  const compContext=useContext(ComponentContext);


  useEffect(() => {
    // mount
    if(!store.comb) {
      store.comb = new reactionCombiner();
      store.comb.addReaction(()=>{
        return props.linker.value.type_code;
      },(newType)=>{
        if(getField()) {
          const field=getField().options;
          for(let i in field) {
            if(typeof props.linker.value[i] === "undefined") {
              switch (field[i].type) {
                case "bool":
                  props.linker.value[i]=typeof field[i].default === "undefined"?0:field[i].default;
                  break;
                case "select":
                  const keys=Object.keys(field[i].options);
                  props.linker.value[i]=typeof field[i].default === "undefined"?keys[0]:field[i].default;
                  break;
                case "string":
                  props.linker.value[i]=typeof field[i].default === "undefined"?"":typeof field[i].default;
                  break;
                case "resize":
                  props.linker.value[i]=typeof field[i].default === "undefined"?{mode:"",quality:""}:typeof field[i].default;
                  break;
              }

            }

          }
        }
      });
    }

    return () => {
      // unmount
      store.comb.clear();
    }
  }, []);

  const getField=()=>{
    if(props.linker.value.type_code) {
      return compContext.field_types.data[props.linker.value.type_code];
    }
    return null;
  };



  return (
    <>
      <tr>
        <td style={{width:'20%'}}>
          <input type="text" className="w100" placeholder="Название" {...input(props.linker.value, "name")} />
        </td>
        <td style={{width:'20%'}}>
          <input type="text" className="w100" placeholder="Код" {...input(props.linker.value, "code")} readOnly={props.linker.value.locked} />
        </td>
        <td style={{width:'20%'}}>
          <FieldTypeSelector  {...custom(props.linker.value, "type_code")} />
        </td>
        <td style={{width:'40%'}}>
          <ShortDescription linker={props.linker} />
        </td>
        <td style={{width:'1%'}}>
          <span onClick={()=>{ props.deleteMe(); }} className="mdi mdi-close fs24 pointer"></span>
        </td>
        <td style={{width:'1%'}}>
          {props.linker.value.type_code?(
            <span onClick={()=>{ runInAction(()=>{ store.show_options=true; }); }} className="mdi mdi-dots-vertical fs24 pointer"></span>
          ):null}
        </td>
      </tr>
      <Popup disablePaddings={true} showed={store.show_options} onHide={()=>{ runInAction(()=>{ store.show_options=false; }); }}>
        <div style={{width: 420}} className="pr ">
          <div className="padd20">
            <div className="up12 splice">
              <div className="cell s-auto fs18 bold pbottom20">Настройки поля</div>
              <div className="cell s-shrink">
                <span className="mdi mdi-close fs24 pointer" onClick={()=>{ runInAction(()=>{ store.show_options=false; }); }}></span>
              </div>
            </div>
            <FieldSettings linker={props.linker} />
          </div>
        </div>
      </Popup>
    </>
  )
};

FieldRow.defaultProps = {};

FieldRow.propTypes = {}

export default observer(FieldRow);
